import { Box, Breadcrumbs, Button, FormControl, FormLabel, Input, Sheet, Stack, Typography, useTheme } from "@mui/joy";

import { useNavigate, useSearchParams } from "react-router";
import { useContext, useEffect, useState } from "react";

import useMediaQuery from '@mui/material/useMediaQuery';

import { LayoutContext } from "../context";
import ModalMessagePane from "../components/MessagesChat/ModalMessagePane";
import MessagesPane from "../components/MessagesChat/MessagesPane";
import ChatsPane from "../components/MessagesChat/ChatsPane";
import { closeMessagesPane, openMessagesPane } from "../utils";
import { APIGetChatMessagesById } from "../api";



const useKeyPress = (targetKey, callback) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === targetKey) {
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [targetKey, callback]);
};



export default function MessagesPage() {
    const { token, loadsUnreadCounts, chats, setChats } = useContext(LayoutContext);

    const [ selectedChat, setSelectedChat ] = useState();
    const [ modalMessage, setModalMessage ] = useState({ open: false });
    
    const [searchParams, setSearchParams] = useSearchParams();
    const chatId = searchParams.get("chatId");
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 'sm' - стандартный breakpoint для мобильных (обычно 600px)

    // Загрузка чата
    const handleChatSelect = async (_chat_data) => {
        try {
            console.log("handleChatSelect", _chat_data);
            // Загружаем последние сообщения при выборе чата
            const messages = await APIGetChatMessagesById(_chat_data?.chat_id, token);
            setSelectedChat({
                ..._chat_data,
                messages: messages
            });
        } catch (error) {
          console.error('Ошибка загрузки сообщений:', error);
        }
    };

    useEffect(() => {
        loadsUnreadCounts();
    }, []);

    useEffect(() => {
        if (!selectedChat) {
            if (isMobile) openMessagesPane();
            else closeMessagesPane();
        }
    }, [isMobile]);

    // Загрузка чата при монтировании, если есть ID в URL
    useEffect(() => {
        console.log("chatId", chatId);
        if (chatId) {
            // toggleMessagesPane();
            setModalMessage({ open: true });
            handleChatSelect(chats.find(itm => itm?.chat_id == chatId));
            const newParams = new URLSearchParams(searchParams);
            newParams.set("chatId", chatId);
            setSearchParams(newParams, { replace: true });
        }
        else {
            setSelectedChat(null);
            setModalMessage({ open: false });
            const newParams = new URLSearchParams(searchParams);
            newParams.delete("chatId");
            setSearchParams(newParams);
        }
    }, [chatId, chats]);

    // Закрытие чата при нажатии Esc
    useKeyPress('Escape', () => {
        if (selectedChat) {
            setSelectedChat(null);
            setModalMessage({ open: false });
            const newParams = new URLSearchParams(searchParams);
            newParams.delete("chatId");
            setSearchParams(newParams);
        } 
    });


    const handleNewChatCreated = (chatId) => {
        // Обновляем URL с новым chatId
        const newParams = new URLSearchParams(searchParams);
        newParams.set("chatId", chatId);
        setSearchParams(newParams, { replace: true });
        // navigate(`/chats?chatId=${chatId}`, { replace: true });
    };


    return (
        <Box sx={{ display: 'flex', height: { xs: 'calc(100dvh - var(--Header-height))', md: '100dvh' } }}>
            <Box
                sx={{
                    // pb: { xs: 2, sm: 2, md: 3 },
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    minHeight: 0,
                    gap: 1,
                    m: 0
                }}
            >
                <Sheet
                    sx={{
                        flex: 1,
                        width: '100%',
                        mx: 'auto',
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'minmax(min-content, min(30%, 400px)) 1fr',
                        },
                    }}
                >
                    <Sheet
                        sx={{
                            position: { xs: 'fixed', sm: 'sticky' },
                            transform: {
                                xs: 'translateX(calc(100% * (var(--MessagesPane-slideIn, 0) - 1)))',
                                sm: 'none',
                            },
                            transition: 'transform 0.4s, width 0.4s',
                            zIndex: 100,
                            width: '100%',
                            // top: 52,
                        }}
                    >
                        <ChatsPane
                            chats={chats}
                            setChats={setChats}
                            selectedChatId={selectedChat?.chat_id}
                            setSelectedChat={setSelectedChat}
                            handleChatSelect={handleChatSelect}
                            onNewChatCreated={handleNewChatCreated}
                        />
                    </Sheet>

                
                    { isMobile ?
                        <ModalMessagePane modalMessage={modalMessage} setModalMessage={setModalMessage}>
                            <MessagesPane
                                chat={selectedChat} 
                                chats={chats}
                                setChats={setChats}
                                searchParams={searchParams}
                                setSearchParams={setSearchParams}
                                setSelectedChat={setSelectedChat}
                            />
                        </ModalMessagePane>
                        :
                        <MessagesPane
                            chat={selectedChat} 
                            chats={chats}
                            setChats={setChats}
                            searchParams={searchParams}
                            setSearchParams={setSearchParams}
                            setSelectedChat={setSelectedChat}
                        />
                    }
                </Sheet>
            </Box>
        </Box>
    );
}